(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-ts-track]');
    var prevBtn = root.querySelector('[data-ts-prev]');
    var nextBtn = root.querySelector('[data-ts-next]');
    var dotsWrap = root.querySelector('[data-ts-dots]');

    if (!track) return;

    var originalCards = Array.prototype.slice.call(track.children);
    var realCount = originalCards.length;
    if (realCount === 0) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;

    var cardsPerView = 1;
    var cloneCount = 1;
    // pos is a continuous slide position over the EXTENDED track
    // (clones + real cards + clones). It always points at a real card,
    // offset by cloneCount so index 0 of the real set sits at pos = cloneCount.
    var pos = 0;
    var dotIndex = 0;
    var autoplayTimer = null;
    var resizeTimer = null;
    var isJumping = false;

    function getCardsPerView() {
      var width = window.innerWidth;
      if (width <= 599) return 1;
      if (width <= 989) return 2;
      var basis = getComputedStyle(root).getPropertyValue('--ts-card-basis') || '33.3333%';
      var pct = parseFloat(basis);
      if (!pct) return 3;
      return Math.max(1, Math.round(100 / pct));
    }

    function clearClones() {
      Array.prototype.slice.call(track.children).forEach(function (child) {
        if (child.hasAttribute('data-ts-clone')) {
          track.removeChild(child);
        }
      });
    }

    function buildClones() {
      clearClones();
      cloneCount = Math.max(cardsPerView, 1);

      for (var i = realCount - cloneCount; i < realCount; i++) {
        var idx = ((i % realCount) + realCount) % realCount;
        var clone = originalCards[idx].cloneNode(true);
        clone.setAttribute('data-ts-clone', 'leading');
        track.insertBefore(clone, track.firstChild);
      }

      for (var j = 0; j < cloneCount; j++) {
        var clone2 = originalCards[j % realCount].cloneNode(true);
        clone2.setAttribute('data-ts-clone', 'trailing');
        track.appendChild(clone2);
      }

      pos = cloneCount + dotIndex;
    }

    function getCardStep() {
      var firstChild = track.children[0];
      if (!firstChild) return 0;
      var rect = firstChild.getBoundingClientRect();
      var styles = getComputedStyle(firstChild);
      var marginLeft = parseFloat(styles.marginLeft) || 0;
      var marginRight = parseFloat(styles.marginRight) || 0;
      return rect.width + marginLeft + marginRight;
    }

    function render(animate) {
      var step = getCardStep();
      track.classList.toggle('ts-animate', !!animate);
      track.style.transform = 'translateX(' + (-step * pos) + 'px)';
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < realCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ts-dot' + (i === dotIndex ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () {
            jumpToReal(idx);
            restartAutoplay();
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.ts-dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === dotIndex);
      });
    }

    function jumpToReal(realIdx) {
      dotIndex = ((realIdx % realCount) + realCount) % realCount;
      pos = cloneCount + dotIndex;
      render(true);
      updateDots();
    }

    function next() {
      pos += 1;
      dotIndex = (dotIndex + 1) % realCount;
      render(true);
      updateDots();
    }

    function prev() {
      pos -= 1;
      dotIndex = ((dotIndex - 1) % realCount + realCount) % realCount;
      render(true);
      updateDots();
    }

    // After the slide animation finishes, if we've moved into the cloned
    // region (past the real set in either direction), silently snap the
    // track back into the real-card region with no transition. Because the
    // clones are exact duplicates, the snap is visually invisible.
    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (isJumping) return;

      if (pos >= cloneCount + realCount) {
        isJumping = true;
        pos -= realCount;
        render(false);
        void track.offsetHeight;
        isJumping = false;
      } else if (pos < cloneCount) {
        isJumping = true;
        pos += realCount;
        render(false);
        void track.offsetHeight;
        isJumping = false;
      }
    });

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      if (autoplay) {
        stopAutoplay();
        startAutoplay();
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        restartAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        restartAutoplay();
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // Drag / swipe support
    var isDragging = false;
    var startX = 0;
    var startTranslate = 0;

    function currentTranslateX() {
      var matrix = window.getComputedStyle(track).transform;
      if (matrix === 'none') return 0;
      var match = matrix.match(/matrix\(([^)]+)\)/);
      if (!match) return 0;
      var parts = match[1].split(',').map(parseFloat);
      return parts[4] || 0;
    }

    function pointerDown(e) {
      isDragging = true;
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
      startTranslate = currentTranslateX();
      track.classList.add('ts-dragging');
      stopAutoplay();
    }

    function pointerMove(e) {
      if (!isDragging) return;
      var x = (e.touches ? e.touches[0].clientX : e.clientX);
      var delta = x - startX;
      track.style.transform = 'translateX(' + (startTranslate + delta) + 'px)';
    }

    function pointerUp(e) {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('ts-dragging');

      var endX = (e.changedTouches ? e.changedTouches[0].clientX : (e.clientX || startX));
      var delta = endX - startX;
      var threshold = 50;

      if (delta > threshold) {
        prev();
      } else if (delta < -threshold) {
        next();
      } else {
        render(true);
      }
      restartAutoplay();
    }

    track.addEventListener('mousedown', pointerDown);
    track.addEventListener('touchstart', pointerDown, { passive: true });
    window.addEventListener('mousemove', pointerMove);
    track.addEventListener('touchmove', pointerMove, { passive: true });
    window.addEventListener('mouseup', pointerUp);
    track.addEventListener('touchend', pointerUp);

    // Prevent image drag ghosting if review cards ever include images
    track.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    function recalc() {
      cardsPerView = getCardsPerView();
      buildClones();
      buildDots();
      render(false);
    }

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(recalc, 150);
    });

    recalc();
    startAutoplay();
  }

  function init() {
    var carousels = document.querySelectorAll('[data-ts-carousel]');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var carousels = e.target.querySelectorAll('[data-ts-carousel]');
    carousels.forEach(initCarousel);
  });
})();